<template>
    <rkm-modal
        extraLarge
        ref="RkmModal"
        title="Adicionar exame"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="form.exames"
                        :validations="validations.exame"
                        label="Exame"
                        show-default-option
                        text-field="descricao"
                        v-model="exameId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-form-checkbox
                        :label="false"
                        :value="true"
                        inline
                        v-model="solicitado"
                    >
                        Solicitado
                    </rkm-form-checkbox>

                    <rkm-form-checkbox
                        :label="false"
                        :value="true"
                        inline
                        v-model="avaliado"
                    >
                        Avaliado
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="include"
                color="primary"
            >
                Incluir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                exame: {required: true},
            }
        },
    },
    data: () => ({
        exameId: null,
        solicitado: false,
        avaliado: false,
    }),
    methods: {
        open() {
            this.resetForm()
            this.$refs.RkmModal.show();
        },
        include() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.solicitado === false && this.avaliado === false) {
                        this.showValidationNotification('É necessário informar se o exame foi avaliado ou solicitado.')
                        return
                    }

                    if (this.model.exames.find(exame => exame.exame.id === this.exameId)) {
                        this.showValidationNotification('O exame já foi incluído.')
                        return
                    }

                    this.model.exames.push({
                        exame: this.form.exames.find(exame => exame.id === this.exameId),
                        solicitado: this.solicitado,
                        avaliado: this.avaliado,
                    })

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.exameId = null
            this.solicitado = false
            this.avaliado = false
        },
    },
    props: {
        form: {type: Object, required: true},
        model: {type: Object, required: true},
    },
};
</script>
